import React from 'react';

import classnames from 'classnames';

import { Loader } from '@nxte-nl/loader';

import {
  LayoutExtensionContainer,
} from '../../containers/LayoutExtensionContainer/LayoutExtensionContainer';
import { ImagePresentational, LinkPresentational } from '../../types/common';
import { SearchResult, SearchResults } from '../SearchResults/SearchResults';
import { SearchSuggestion, SearchSuggestions } from '../SearchSuggestions/SearchSuggestions';
import { SearchTerms } from '../SearchTerms/SearchTerms';
import styles from './Search.module.css';

export type SearchHighlightedBlock = {
  backgroundImage: ImagePresentational;
  cardImage: ImagePresentational;
  description: string;
  referencedPath: string;
  showHand: boolean;
  title: string;
};

export type Props = {
  highlightedBlocks?: SearchHighlightedBlock[];
  loadingResults: boolean;
  loadingSuggestions: boolean;
  searchResult?: SearchResult[] | null;
  showSuggestions: boolean;
  suggestions?: SearchSuggestion[];
  terms?: LinkPresentational[];
};

export const Search: React.FC<Props> = React.memo(
  ({
    terms,
    suggestions,
    highlightedBlocks,
    loadingResults,
    loadingSuggestions,
    showSuggestions,
    searchResult,
  }) => {
    const loading = React.useMemo(() => loadingResults || loadingSuggestions, [
      loadingResults,
      loadingSuggestions,
    ]);

    return (
      <div
        className={classnames(styles.wrapper, {
          [styles.loading]: loading,
        })}
      >
        {loading ? (
          <Loader />
        ) : (
          <div className={styles.searchContainer}>
            <LayoutExtensionContainer>
              {({ layoutExtension }) =>
                showSuggestions ? (
                  <div className={styles.search}>
                    <SearchTerms terms={terms} />

                    <SearchSuggestions
                      suggestions={suggestions}
                      highlightedBlocks={highlightedBlocks}
                      layoutExtension={layoutExtension}
                    />
                  </div>
                ) : (
                  <SearchResults results={searchResult} layoutExtension={layoutExtension} />
                )
              }
            </LayoutExtensionContainer>
          </div>
        )}
      </div>
    );
  },
);

Search.displayName = 'Search';
